import { apiClient } from './client'
import type { UserRole } from '@/types'

export const authApi = {
  login: (role: UserRole, password?: string) =>
    apiClient.post('/api/login', { role, password: password ?? undefined }),

  loginEmail: (email: string, password: string) =>
    apiClient.post('/api/login', { email, password }),

  acceptInvite: (token: string, password: string) =>
    apiClient.post('/api/auth/accept-invite', { token, password }),

  checkInvite: (token: string) =>
    apiClient.get<{ email: string; status: 'pending' | 'used' | 'expired' }>(`/api/auth/invite/${encodeURIComponent(token)}`),

  logout: () =>
    apiClient.post('/api/logout'),

  check: () => apiClient.get('/api/session'),
}
